import { render, staticRenderFns } from "./PcDownloadIcon.vue?vue&type=template&id=bda2cbb4&scoped=true"
import script from "./PcDownloadIcon.vue?vue&type=script&lang=js"
export * from "./PcDownloadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda2cbb4",
  null
  
)

export default component.exports